module.exports = __webpack_public_path__ + "static/media/8en.ff7f98d8.jpg";